/*
Utils -- 1.2.1
this script is stable for GTM or theme
*/

// fallback support for GTM + 1st party definitions
var base_url = "{{*Base URL}}";
if(base_url.indexOf(".") == -1){
  // *Base URL is not defined or not available
  base_url = window.location.hostname;
}

// HELPER FUNCTIONS

function gtm_add_cartAttribute(attr_name, attr_val, multiple_attr_array) {
  if (typeof multiple_attr_array === 'undefined') multiple_attr_array = [];
  
  var body_attributes = "attributes[" + attr_name + "]=" + attr_val;
  if (multiple_attr_array.length > 0) {
    body_attributes = multiple_attr_array.join('&'); 
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: body_attributes
  })
  .then(function(response) {
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return response.json();
  })
  .then(function(data) {
    console.log('Cart updated successfully:', data);
    window.cart_attributes_updated = true;
  })
  .catch(function(error) {
    console.error('Failed to update cart:', error);
  });
}

// add experiment data to cart
setTimeout(function() {
  // 7.5s timeout is to allow tags to initialize, sub 8s pageviews are rarely valid anyhow
  var exp_cart_data = [];
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    
    // Loop through the dataLayer 
    for (var i = 0; i < window.dataLayer.length; i++) {
      var dl_item = window.dataLayer[i];
      if (dl_item && typeof dl_item === 'object' && dl_item.event == "proteus_experiment_pageview") {
        var exp_id = dl_item.proteus_exp_id;
        var exp_var = dl_item.proteus_var_id;
        exp_cart_data.push("attributes[proteus-experimentation-" + exp_id.toLowerCase() + "]=[" + exp_id + "]" + exp_var);
        if (i == window.dataLayer.length - 1 && exp_cart_data.length > 0) {
          // last loop
          console.log("add cart attributes exp_cart_data", exp_cart_data);
          gtm_add_cartAttribute(false, false, exp_cart_data);
        }     
      }
    }
    
  }

}, 7500);

function gtm_getVariation(number_of_variations) {
  try {
    return "v" + Math.floor(Math.random() * number_of_variations);
  } catch (e) {
    console.error('Error in gtm_getVariation:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_getLimitedVariation(number_of_variations, percentage_to_v0) {
  try {
    if (Math.random() < percentage_to_v0) {
      return "v0";
    }
    // Decrement number_of_variations since "v0" is now out of the equation
    return "v" + (1 + Math.floor(Math.random() * (number_of_variations - 1)));
  } catch (e) {
    console.error('Error in gtm_getVariation:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_getParam(name, optSearch) {
  'use strict';
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function gtm_getCookie(name) {
  try {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
  } catch (e) {
    console.error('Error in gtm_getCookie:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_setCookie(name, value, days) {
  try {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=." + base_url;
  } catch (e) {
    console.error('Error in gtm_setCookie:', e.message);
  }
}

function gtm_deleteCookie(name, path, domain) {
  document.cookie = name + '=; ' +
    (path ? 'path=' + path + '; ' : 'path=/; ') +
    (domain ? 'domain=' + domain + '; ' : '') +
    'expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function waitForElement(selector) {
  return new Promise(function(resolve, reject) {
    var element = document.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var nodes = Array.prototype.slice.call(mutation.addedNodes);
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}

// shim layer with setTimeout fallback
var requestAnimFrame = (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
})();

function waitUntil(test) {
  return new Promise(function(resolve) {
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
}

function observeSelector(selector, callback, options) {
  if (typeof options === 'undefined') options = {
    timeout: null,
    once: false,
    onTimeout: null,
    document: window.document
  };

  var processed = new Map();

  if (options.timeout || options.onTimeout) {
    console.log('WARNING: observeSelector options timeout and onTimeout are not yet implemented.');
  }

  var obs, isDone = false;
  var done = function() {
    if (!obs) console.warn('observeSelector failed to run done()');
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    isDone = true;
  };

  var processElement = function(el) {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };

  var lookForSelector = function(el) {
    if (typeof el === 'undefined') el = document;
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      var elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
          el = elements[i];
          if (processElement(el)) return true;
        }
      }
    }
  };
  lookForSelector();

  if (!isDone) {
    obs = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(record) {
        if (record && record.addedNodes && record.addedNodes.length) {
          for (var i = 0; i < record.addedNodes.length; i++) {
            var el = record.addedNodes[i].parentElement;
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }

  return function() {
    done();
  };
} // _observeSelector
